<template>
  <div class="layout-container">
    <el-tabs type="border-card">
      <el-tab-pane label="专题模板">
        <div style="background: #ffffff; position: relative">
          <div class="search-condition-con" :class="'show'">
            <div class="search-condition">
              <span class="label">模板名称</span>
              <div class="input-condition">
                <el-input
                  v-model="condition.name"
                  placeholder="可输入关键词查找"
                ></el-input>
              </div>
            </div>
           
            <div class="search-condition" style="width: 40%; max-width: 500px">
              <span class="label">上传时间</span>
              <div class="input-condition">
                <el-date-picker
                  v-model="condition.date"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="btn-condition">
            <el-button type="primary" @click="handleSearch()">查 询</el-button>
            <el-button @click="resetSearch()">清空条件</el-button>
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd()"
              v-permission="'operating.topic.template.create'"
              >上传模板</el-button
            >
          </div>
        </div>
        <div class="clearfix">
            <div class="model-item floatL"  v-for="(item, key) in list" :key="key">
                <div class="img-wrapper">
                    <img :src="item.cover_img" />
                </div>
                <p class="name els" :title="item.name">{{item.name}}</p>
                <p class="time">{{item.created_at}}</p>
                <div class="btn">
                    <a :href="item.path">下载</a>
                    <el-button v-permission="'operating.topic.template.delete'" size="mini" @click="deleteModel(item.id)">删除</el-button>
                </div>
            </div>
        </div>
        <template v-if="list.length > 0">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :current-page="condition.page"
            :total="condition.total"
            :page-size="condition.per_page"
            @current-change="currentChange"
          ></el-pagination>
        </template>
        <div v-else class="none-data">
            暂无数据
        </div>
      </el-tab-pane>
    </el-tabs>
    <add-model ref="addModelRef" :callback="initData"></add-model>
  </div>
</template>

<script>
import { parseTime } from "@/utils";
import { topicModelList, deleteTopicModel } from "@/service/zhuanti";
import addModel from './add'
export default {
  name: "List",
  components: {
      addModel
  },
  data() {
    return {
      list: [],
      condition: {
        name: null,
        data: [],
        page: 1,
        total: null,
        per_page: 10
      },
      isLoading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
   mounted () {
        this.initData()
    },
  methods: {
    handleAdd() {
        this.$refs.addModelRef.open()
    },
    handleSearch() {
      if (this.condition.date && this.condition.date.length > 0) {
        this.condition.created_at_start = parseTime(this.condition.date[0]);
        this.condition.created_at_end = parseTime(this.condition.date[1]);
      }
      this.initData();
    },
    resetSearch() {
      this.condition = {
        name: null,
        date: [],
        page: 1,
        total: null,
        per_page: 10
      };
        this.initData();
    },
    async initData() {
      this.isLoading = true;
      await topicModelList(this.condition).then((data) => {
        this.list = [];
        this.list = data.data;
        this.condition.total = parseInt(data.total);

      });
      this.isLoading = false;
    },
    currentChange (index) {
      this.condition.page = index
      this.initData()
    },
    deleteModel(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteTopicModel(id)
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.initData();
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err.message || "删除失败",
            });
          });
      });
    },
  },
};
</script>

<style scoped>
.model-item {
  width: 17%;
  margin-right: 2%;
  margin-left:1%;
  margin-bottom:20px;
}
.model-item .img-wrapper{
    width: 100%;
    height:250px;
    background-color: #DCDFE6;
}
.model-item img{
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.model-item p{
    margin: 5px 0;
    font-size:14px;
    line-height:24px;
}
.model-item .btn a{
    text-decoration: none;
    padding: 5px 15px;
    font-size: 12px;
    border-radius: 3px;
    margin-right: 20px;
    border: 1px solid #DCDFE6;
    color: #606266;
}
.model-item .btn a:hover{
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
.none-data{
    text-align: center;
    line-height:100px;
    color:#999;
}
.els {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
